import styled from 'styled-components';

export const Filter = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-m);
`;

export const FilterName = styled.span`
  margin-right: var(--spacing-m);
  svg {
    margin-right: 5px;
  }
`;
